import React from "react";
import { Text } from "react-native";
import type { TextProps } from "react-native";

import { useCustomTheme } from "../hooks/useCustomTheme";
import type { FontStyle } from "../types";

type ThemedTextWithBoldProps = {
  textContent: string;
  style?: TextProps["style"];
  fontDefault?: FontStyle;
  fontBold?: FontStyle;
};

type TextPart = {
  text: string;
  bold: boolean;
  key: number;
};

const parseTextWithBold = (text: string) => {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return {
        text: part.slice(2, -2),
        bold: true,
        key: index,
      };
    }
    return {
      text: part,
      bold: false,
      key: index,
    };
  });
};

export const ThemedTextWithBold = ({
  style,
  textContent,
  fontDefault,
  fontBold,
}: ThemedTextWithBoldProps) => {
  const { fonts } = useCustomTheme();
  const parsedText = React.useMemo(
    () => parseTextWithBold(textContent),
    [textContent],
  );

  return (
    <Text>
      {parsedText.map((part: TextPart) => (
        <Text
          key={part.key}
          style={[
            style,
            part.bold
              ? (fontBold ?? fonts.bold)
              : (fontDefault ?? fonts.regular),
          ]}
        >
          {part.text}
        </Text>
      ))}
    </Text>
  );
};
